import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-work-item-cloning',
  templateUrl: './work-item-cloning.component.html',
  styleUrls: ['./work-item-cloning.component.css']
})
export class WorkItemCloningComponent implements OnInit {

  //lstDropDown: any = [];
  docTypeList: any = [];
  strURN: string = '';
  // strComments: string = '';
  selectedDocumentType: any;
  lstURNData: any = [];
  chnageTypeColumnsToHide: any = ['DOCUMENT_DETAIL_ID', 'PROCESS_ID'];
  selectedRecords: any = [];
  Project_id = 0;
  restrictedKeywords: any = [];
  isCommentExpand: boolean = false;
  isSubDocumentExists: boolean = false;
  modalReference: any;
  isDataFound: boolean = false;
  isApproved: boolean = false;
  // WorkITem Creation Range
  isWorkItemDateRangeHasValue = false;
  maxDate = new Date();
  workItemCreationDateRange = new FormGroup({
    work_item_start_date: new FormControl(),
    work_item_end_date: new FormControl(),
  });


  // Invoice Creation Range
  isDateRangeHasValue = false;
  //maxDate = new Date();
  invoiceCreationDateRange = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl(),
  });

  @ViewChild('invoiceSubmittedModal') invoiceSubmittedModal: ElementRef;

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private route: Router,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {
    //wowService.init();
  }

  ngOnInit(): void {
    this.restrictedKeywords = this.commonService.getRestrictedKeywords();
    this.getDocumentTypes();
    this.Project_id = this.commonService.selectedProject;

  }


  getDocumentTypes() {
    this.docTypeList = [];
    let params = new HttpParams();
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));

    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    this.dataService.getData('document-types', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            res.data.forEach((element) => {
              this.docTypeList.push({
                value: element.document_type_id,
                text: element.document_type_name
              });
            });

            this.selectedDocumentType = this.docTypeList.length > 0 ? this.docTypeList[0].value : '';
            this.onSelectDocumentType(this.selectedDocumentType);
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }

      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }

  onSelectDocumentType(docId) {
    if (this.lstURNData.length > 0) {
      this.lstURNData.splice(0, this.lstURNData.length)
    }
    this.isDataFound = false;
  }

  getOpenSearchData() {


    let invalidSubmitMsg = '';

    let objDocType = this.docTypeList.find(el => el.value == this.selectedDocumentType);

    invalidSubmitMsg += typeof objDocType !== "undefined" && objDocType.value != 0 ? '' : '-Please select work item type.\r <br/>';
    if (invalidSubmitMsg != '') {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Work Item Cloning');

    }
    else {

      let invoice_dateRange: any = { start_date: '', end_date: '' };
      let invoice_dt: string = "";

      if (this.isDateRangeHasValue) {
        invoice_dateRange = {
          start_date: this.commonService.dateFormating(
            this.invoiceCreationDateRange.value.start_date
          ),
          end_date: this.commonService.dateFormating(
            this.invoiceCreationDateRange.value.end_date
          ),
        };
        invoice_dt = invoice_dateRange.start_date + '/' + invoice_dateRange.end_date;

      }
      let create_dateRange: any = { start_date: '', end_date: '' };

      let create_dt: string = "";
      if (this.isWorkItemDateRangeHasValue) {
        create_dateRange = {
          start_date: this.commonService.dateFormating(
            this.workItemCreationDateRange.value.work_item_start_date
          ),
          end_date: this.commonService.dateFormating(
            this.workItemCreationDateRange.value.work_item_end_date
          ),
        };
        create_dt = create_dateRange.start_date + '/' + create_dateRange.end_date;
      }
      let obj = {
        action: "FILTER",
        projectId: this.commonService.selectedProject,
        documentTypeId: this.selectedDocumentType,
        urn: this.strURN,
        durationCreateDate: create_dt,
        durationInvoiceDate: invoice_dt

      }


      if (this.lstURNData.length > 0) {
        this.lstURNData.splice(0, this.lstURNData.length)
      }


      this.dataService.getData('getWorkItemCloningFilter', obj).subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              if (res ?.data ?.Table.length > 0) {
                res.data.Table.forEach((element) => {
                  element["action_dropdown_option_To Work Item Type*"] = JSON.parse(element["action_dropdown_option_To Work Item Type*"])
                  element["action_dropdown_multi_option_Action*"] = JSON.parse(element["action_dropdown_multi_option_Action*"])

                });

                this.lstURNData = res.data.Table;
                this.isDataFound = true;
              }
              else {
                this.commonService.showMessageBox('No Data Found', 'Work Item Cloning');
                this.isDataFound = false;
              }

            }
            else {
              this.isDataFound = false;
              this.commonService.showMessageBox('No Data Found', 'Work Item Cloning');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.route.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
    }

  }
  ClearOpenSearch() {

    this.strURN = '';
    this.resetInvoiceCreationDateRange();
    this.resetWorkItemCreationDateRange();
    this.selectedDocumentType = this.docTypeList.length > 0 ? this.docTypeList[0].value : '';
    if (this.lstURNData.length > 0) {
      this.lstURNData.splice(0, this.lstURNData.length)
    }
    this.isDataFound = false;
  }

  onInvoiceCreationDateChanges() {
    if (
      this.invoiceCreationDateRange.value.start_date != '' ||
      this.invoiceCreationDateRange.value.end_date != ''
    ) {
      this.isDateRangeHasValue = true;
    }
  }

  resetInvoiceCreationDateRange() {
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }

  onWorkItemCreationDateChanges() {
    if (
      this.workItemCreationDateRange.value.work_item_start_date != '' ||
      this.workItemCreationDateRange.value.work_item_end_date != ''
    ) {
      this.isWorkItemDateRangeHasValue = true;
    }
  }

  resetWorkItemCreationDateRange() {
    this.workItemCreationDateRange = new FormGroup({
      work_item_start_date: new FormControl(),
      work_item_end_date: new FormControl(),
    });
    this.isWorkItemDateRangeHasValue = false;
  }

  cellClickEvent(event: any) {
  }

  // checkRestrictedKeywords(formControlName: string) {
  //   let foundedRestrictedKeyword = [];
  //   var input = this.strComments;
  //   this.restrictedKeywords.forEach((keyword) => {
  //     if (input.includes(keyword.restrict)) {
  //       input = this.replaceAll(input, keyword.restrict, keyword.replace);
  //       foundedRestrictedKeyword.push(keyword.restrict);
  //     }
  //   });
  //   if (foundedRestrictedKeyword.length > 0) {
  //     this.strComments = input;
  //     this.commonService.showMessageBox(
  //       'We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.',
  //       'Warning'
  //     );
  //   }
  // }

  replaceAll(str, find, replace) {
    var escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    return str.replace(new RegExp(escapedFind, 'g'), replace);
  }
  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  sumbitData() {

    let invalidSubmitMsg = '';

    //invalidSubmitMsg += typeof this.strComments !== "undefined" && this.strComments != '' ? '' : '-Please enter comment.\r <br/>';

    // if (invalidSubmitMsg != '') {
    //   this.commonService.showMessageBox(invalidSubmitMsg, 'Work Item Cloning');

    // }
    //else {

    let dataList: any = [];
    this.lstURNData ?.every((element) => {
      if (element.action_checkbox_button == true) {

        let newDocumentId = 0, newSubDocumentId = 0, actions = "";
        element["action_dropdown_option_To Work Item Type*"] ?.forEach(val => {

          if (val.selected) {
            newDocumentId = val.value;
          }

        })

        if (newDocumentId == 0) invalidSubmitMsg += "Please select To Work Item Type for " + element["URN"];

        if (element["action_dropdown_option_To Category*"] != "") {
          element["action_dropdown_option_To Category*"] ?.forEach(val => {

            if (val.selected) {
              newSubDocumentId = val.value;
            }

          })
          if (newSubDocumentId == 0) invalidSubmitMsg += "Please select category for" + element["URN"];
        }

        element["action_dropdown_multi_option_Action*"] ?.forEach(val => {

          if (val.selected) {
            actions += val.value + ",";
          }

        })

        if (actions == "") invalidSubmitMsg += "</br>Please select at least one Action for " + element["URN"];


        if (invalidSubmitMsg != "") {
          return false;
        }

        let obj = {
          DocumentDetailId: element.DOCUMENT_DETAIL_ID,
          SrcDocumentTypeId: this.selectedDocumentType,
          DestDocumentTypeId: newDocumentId,
          DestSubDocTypeId: newSubDocumentId,
          Actions: actions,
          Reason: '', //this.strComments,
          // UserId: this.commonService.getUserInfoFromLocalStorage('userId')
          UserId: this.memorystore.getItem('userId')
        }
        dataList.push(obj);

      }
      return true;
    });

    if (invalidSubmitMsg != "") {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Work Item Cloning');

    }
    else {

      if (dataList.length <= 0) {
        this.commonService.showMessageBox('Please select at least one URN to change the work item.', 'Work Item Cloning');
      }
      else {
        if (this.isApproved == false) {
          this.showModal(this.invoiceSubmittedModal, 'lg');
        }
        else {

          this.isApproved = false;

          let initial_params = {
            lstParameter: dataList
          }
          this.dataService.postData('postWorkItemCloning', initial_params).subscribe((res) => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
              if (res.status != null) {
                this.commonService.showMessageBox('Work Item Cloned for ' + dataList.length + ' URN(s).', 'Work Item Cloning');
                this.isDataFound = false;
                // this.strComments = "";
                if (this.lstURNData.length > 0) {
                  this.lstURNData.splice(0, this.lstURNData.length)
                }

              }
            }
            else {
              if (res.errorCode != 0 && res.errorCode == 4000) {
                this.route.navigateByUrl('/unauthorized');
                return;
              }
              if (res.errorCode != 0 && res.errorCode == 3000) {
                this.commonService.showMessageBox("Internal error")
              }
            }
          },
            error => {
              if (error.includes("401")) {
                this.route.navigateByUrl('/unauthorized');
                return;
              }
            });
        }
      }
    }
  }

  processInvoice() {
    this.isApproved = true;
    this.sumbitData();
  }

  dropDownClickEvent(event: any) {
    if (event.colName == "action_dropdown_option_To Work Item Type*") {
      let obj = {
        action: "BIND_CATEGORY",
        projectId: this.commonService.selectedProject,
        documentTypeId: event.event.value,
        urn: '',
        durationCreateDate: '',
        durationInvoiceDate: ''

      }

      if (this.lstURNData[event.index]["action_dropdown_option_To Category*"] ?.length > 0) {
        this.lstURNData[event.index]["action_dropdown_option_To Category*"].splice(0, this.lstURNData[event.index]["action_dropdown_option_To Category*"].length)
      }


      this.dataService.getData('getWorkItemCloningFilter', obj).subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res != null && res.data != null) {
              if (res ?.data ?.Table.length > 0) {
                this.lstURNData[event.index]["action_dropdown_option_To Category*"] = res.data.Table;
              }
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.route.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }
        },
        error => {
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        });
    }
  }

  gridCellClickEvent(event: any) {
    if (event.columnName.toLowerCase() == 'urn') {
      let data = {
        documentDetailId: event.rowData['DOCUMENT_DETAIL_ID'],
        isReadonlyMode: true
      }
      EmmiterService.get("transactionLiteModal").emit(data);
    }
  }


}

